import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import config from '../../config'

import {
  IGetPutRequest,
  IUseUpdateMutation,
  IUpdateFn,
  ISafetyCaseHazard,
  ISafetyCaseHazardUpdateUpsert,
} from '../../interfaces'

const getUpdateSafetyCaseHazardMutationRequest: IGetPutRequest = () => ({
  method: 'put',
  url: `${config.baseUrl}/sms/Hazards/`,
})

const useUpdateSafetyCaseHazardMutation: IUseUpdateMutation<ISafetyCaseHazard, ISafetyCaseHazardUpdateUpsert> =
  (params, options = {}) => {
    const request = useMemo(() => getUpdateSafetyCaseHazardMutationRequest(params), [params])

    const updateSafetyCase: IUpdateFn<ISafetyCaseHazardUpdateUpsert, ISafetyCaseHazard> = useCallback(
      async data => axios({ ...request, url: request.url + data.id, data }).then(res => res.data),
      [request],
    )

    const response = useMutation<ISafetyCaseHazard, Error, ISafetyCaseHazardUpdateUpsert>({
      mutationFn: updateSafetyCase,
      ...options,
    })

    return response
  }

export default useUpdateSafetyCaseHazardMutation
